module.exports = __webpack_public_path__ + "img/joker_320.f8aa58a6.png";